import { BackupOutlined } from "@mui/icons-material";
import React, { useRef, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";
import { auntySvg, greenGirl, redGirl } from "../../assets/images/imagePath";
import {
  mainBgImages,
  rangeSliderStyles,
} from "../../handlers/helperFunctions";
import Input from "../Input";
import classes from "./BgImage.module.css";
import { ReactImgInput } from "react-img-input";
import "react-img-input/dist/index.css";

const BgImagePopoverChildren = ({ setMainBg, opacity, setOpacity }) => {
  const ref = useRef(null);
  const [selected, setSelected] = useState(0);
  const config = {
    size: 120,
    captureBtn: {
      bg: "crimson",
      color: "#fff",
    },
    cropBtn: {
      bg: "#F4B230",
      color: "#fff",
    },
    defaultImg: "",
    theme: "light",
    compression: {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 500,
      useWebWorker: true,
    },
  };
  const handleImageChange = (img, e) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(img);
    reader.onload = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;

      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        console.log(height,"height height height")
        console.log(width,"width width width")
        // if (height > 270 && width > 198) {
          setMainBg(image.src);
          setSelected(e.target.value);
        // } else if (height < 270 || width < 198) {
        //   toast.warn(
        //     "Uploaded image Height must be greater than 270px and Width 198px."
        //   );
        // }
      };
    };
  };

  return (
    <>
      <style>
        {`
          .activated{
            position: absolute;
            top: 4px;
            right: 3px;
            color: red;
          }
          
        `}
      </style>

      <div className={classes.main_div}>
        {opacity && (
          <div className={classes?.group}>
            <label>Select Opacity</label>
            <Input
              type={"range"}
              min={0}
              max={1}
              step={0.1}
              placeholder={"Select..."}
              value={opacity}
              setter={setOpacity}
              inputStyle={rangeSliderStyles}
            />
          </div>
        )}
        {mainBgImages.map((item, index) => {
          return (
            <div className={classes.img_head}>
              <ReactSVG
                src={item}
                className={classes?.mainBgImg}
                draggable={false}
                onClick={(e) => {
                  setSelected(index);
                  setMainBg(item);
                }}
              />
              {selected == index && (
                <div className="activated">
                  <AiFillCheckCircle className={classes?.galleryItemSelected} />
                </div>
              )}
            </div>
          );
        })}
        {/* <div className={"upload_div"}>
          <button onClick={() => ref.current.click()}>Upload Image</button>
          <input
            ref={ref}
            style={{ display: "none" }}
            type="file"
            onChange={(e) => {
              handleImageChange(e.target.files[0], e);
              //   setMainBg(e.target.files[0]);
            }}
          />
        </div> */}
        <ReactImgInput
          config={config}
          setOutput={(e) => {
            const url = e;
            fetch(url)
              .then((res) => res.blob())
              .then((blob) => {
                const file = new File([blob], "File name", {
                  type: "image/png",
                });
                handleImageChange(file);
                console.log(file, "qweeeee");

                // setSubmitPhoto(file);
              });
          }}
        />
      </div>
    </>
  );
};

export default BgImagePopoverChildren;
